// extracted by mini-css-extract-plugin
module.exports = {"profileListContainer":"List_profileListContainer__3Pc2P","noData":"List_noData__QMxAB"};